import { render, staticRenderFns } from "./detail_change_pass_security_page.vue?vue&type=template&id=0341e6a7&scoped=true"
import script from "./detail_change_pass_security_page.vue?vue&type=script&lang=js"
export * from "./detail_change_pass_security_page.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0341e6a7",
  null
  
)

export default component.exports